import Icon from './Icon';
import { useAuth } from '../context/AuthContext';
import { useTeamAgents } from '../hooks/useTeamAgents';
import { useTerritories } from '../context/TerritoriesContext';

// Role-aware scope banner — ported from the frozen mockup (v0.7) `scopeBanner()`,
// driven by the real auth profile (territoryIds / tenantIds) instead of mock data.
export default function ScopeBanner() {
  const { role, territoryIds = [], tenantIds = [] } = useAuth();
  const { terrLabel } = useTerritories();
  const teamAgents = useTeamAgents(); // [] unless manager

  let body;
  if (role === 'agent') {
    const terr = territoryIds.map((id) => terrLabel(id)).join(' · ') || 'your assigned territories';
    body = <><b>Agent</b> — you see only your assigned leads &amp; territories: <b>{terr}</b>.</>;
  } else if (role === 'manager') {
    const names = teamAgents.map((a) => a.name).filter(Boolean).join(', ');
    body = <><b>Manager</b> — only your team&apos;s agents{names ? <> (<b>{names}</b>)</> : ''} and their territories.</>;
  } else if (role === 'owner') {
    const n = tenantIds.length || 1;
    body = <><b>Owner</b> — full view of all {n} tenant{n === 1 ? '' : 's'} you own. Switch tenants in the top bar.</>;
  } else {
    body = <><b>HQ Admin · God View</b> — every tenant, team, and agent.</>;
  }

  return (
    <div className="scope-banner">
      <Icon name="audit" size={16} />
      <span>{body}</span>
    </div>
  );
}
